import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'
import { Button, Container, Icon } from 'semantic-ui-react'
import { FaRegFlag } from 'react-icons/fa'
import { loadPegiList, removePegi, updateState } from '../Slice/PegiSlice'
import ListTable from '../../Common/Views/ListTable'
import DeleteConfirmModal from '../../Common/Views/DeleteConfirmModal'
import './css/PegiListPage.css'

export default function PegiListPage () {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const {
    list,
    filter,
    totalPages,
    isLoading,
    isError,
    message
  } = useSelector((state) => state.pegi)
  const [deletePegi, setDeletePegi] = useState({})

  const columns = [
    {
      name: 'id',
      title: 'generic.id',
      filter: false,
      props: {
        textAlign: 'right',
        width: 1
      }
    },
    {
      name: 'name',
      title: 'generic.name'
    }
  ]

  useEffect(() => {
    onReload(filter)
  }, [])

  const onReload = (payload) => {
    dispatch(loadPegiList(payload))
  }

  useEffect(() => {
    if (isError && message) {
      toast.error(message)
      dispatch(updateState())
    }
  }, [isError, message])

  const onEdit = (pegiId) => {
    navigate(`/pegi/${pegiId}`)
  }
  const onDelete = (pegi) => {
    setDeletePegi(pegi)
  }

  const handleDeletePegi = () => {
    dispatch(removePegi(deletePegi.id))
    setDeletePegi({})
  }

  return (
    <Container className='pegi-list-page'>
      <div className='pegi-title'>
        <Icon size='large'><FaRegFlag /></Icon>
        <span>{ t('menu.pegi') }</span>
        <Button
          floated='right'
          icon
          labelPosition='left'
          primary
          size='large'
          onClick={() => navigate('/pegi/new')}>
          <Icon name='flag outline' /> { t('pegi.new') }
        </Button>
      </div>
      <ListTable color='brown'
                 isLoading={isLoading}
                 columns={columns}
                 filter={filter}
                 data={list}
                 totalPages={totalPages}
                 onReload={onReload}
                 onEdit={onEdit}
                 onDelete={onDelete} />
      <>
        <DeleteConfirmModal open={ !!deletePegi.id }
                            title={ t('pegi.deleteTitle') }
                            message={ t('pegi.deleteQuestion') }
                            item={ deletePegi.name }
                            onCancel={ () => setDeletePegi({}) }
                            onDelete={ handleDeletePegi } />
      </>
    </Container>
  )
}
